/**
 * Sonner toaster — themed to match the industrial-telemetry palette.
 * Mount <Toaster /> once at the app root, then call `toast.success(...)`
 * etc. from anywhere.
 */
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-elevated font-sans",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:!border-signal-live/40",
          error: "group-[.toaster]:!border-destructive/40",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
export { toast } from "sonner";
